import React from 'react'

import { Field } from 'formik'

import { Col, Form, Row } from '_zari/core'

const UsoDetraccionFormGroup = ({ iValue, handleChange, resetForm, initialValues }) => {
  const onChange = React.useCallback(
    e => {
      handleChange(e)

      resetForm({
        values: {
          ...initialValues,
          usoDetraccion: e.target.value
        }
      })
    },
    [handleChange, resetForm, initialValues]
  )

  return (
    <Form.Group>
      <Form.Label text='USO DETRACCION' md={5} alignRightAt='md' />
      <Col md={7}>
        <Row>
          <Col md={6}>
            <Field name='usoDetraccion'>
              {({ field }) => <Form.Radio {...field} id='usoDetraccion-si' checked={iValue === 'true'} value={true} label='SI' />}
            </Field>
          </Col>
          <Col md={6}>
            <Field name='usoDetraccion'>
              {({ field }) => (
                <Form.Radio {...field} onChange={onChange} id='usoDetraccion-no' checked={iValue === 'false'} value={false} label='NO' />
              )}
            </Field>
          </Col>
        </Row>
      </Col>
    </Form.Group>
  )
}

export default React.memo(UsoDetraccionFormGroup)
